import { useNavigate } from 'react-router'
import styled from 'styled-components'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <ErrorMsg>
      <h1>페이지가 없습니다</h1>
      <span onClick={() => navigate(-1)}>돌아가기</span>
    </ErrorMsg>
  )
}

const ErrorMsg = styled.div`
  width: 100%;
  padding-top: 160px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  align-items: center;

  h1 {
    font-size: 70px;
  }

  span {
    cursor: pointer;
    font-size: 20px;
    color: #171783;
  }
`

export default NotFound
